import { render } from "./Texteditor.vue?vue&type=template&id=d652b7f8"
import script from "./Texteditor.vue?vue&type=script&lang=js"
export * from "./Texteditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__